// Landing/scope copy. The example app read this from content/site.json; the
// only field the report engine consumes is `scope.note`, so the content is
// inlined here rather than shipping a JSON asset. Hero copy is retained for
// shape compatibility with the standalone app's SiteContent type.

export type SiteContent = {
  hero: {
    eyebrow: string;
    headline: string; // may contain HTML markup
    body: string;
    ctaPrimary: string;
    ctaSecondary: string;
  };
  scope: {
    note: string;
  };
};

export const siteContent: SiteContent = {
  hero: {
    eyebrow: "AI-Era Cyber Defense",
    headline: "Assess your defenses against AI-era cyber threats",
    body: "A maturity assessment grounded in Cisco's Customer Playbook for responding to AI-era cyber threats.",
    ctaPrimary: "Start the assessment",
    ctaSecondary: "Learn more",
  },
  scope: {
    note: "Covers all three workstreams from Cisco's Customer Playbook — Advance Your Operating Model, Modernize Your Infrastructure, and Elevate Your Security Posture.",
  },
};
